import { render, staticRenderFns } from "./ThreeComposition.vue?vue&type=template&id=d1d7b030&"
import script from "./ThreeComposition.vue?vue&type=script&lang=js&"
export * from "./ThreeComposition.vue?vue&type=script&lang=js&"
import style0 from "./ThreeComposition.vue?vue&type=style&index=0&id=d1d7b030&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports